import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const IMAGETWOCOLSBLOCK_LEGACY_FIELD_ORDER = [
  "image_left",
  "image_right"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  imageTwoColsBlockDescriptor: _generatedImageTwoColsBlockDescriptor,
  imageTwoColsBlockBlocDefinition,
  imageTwoColsBlockDashboardLayout,
  imageTwoColsBlockConfig,
  imageTwoColsBlockResolveConfig,
  imageTwoColsBlockProperties,
} = doodBlockConfig(
  {
    name: "Image - Two columns",
    componentType: 'ImageTwoColsBlockComponent',
    category: 'content',
    description: "Image - Two columns.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
  },

  () => ({
    image_left: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.image-two-cols.image-left.label",
        help: "pages.blocks.image-two-cols.image-left.help",
      }
    }),
    image_right: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.image-two-cols.image-right.label",
        help: "pages.blocks.image-two-cols.image-right.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.image-two-cols.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.image-two-cols.fieldset.images.label",
            fields: ["image_left", "image_right"],
          },
        ],
      },
    ],
  })
);

export function imageTwoColsBlockDescriptor(): IBlockDescriptor;
export function imageTwoColsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function imageTwoColsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedImageTwoColsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedImageTwoColsBlockDescriptor, imageTwoColsBlockProperties, fieldOrder);
}

export {
  imageTwoColsBlockBlocDefinition,
  imageTwoColsBlockDashboardLayout,
  imageTwoColsBlockProperties,
  imageTwoColsBlockConfig,
  imageTwoColsBlockResolveConfig,
};

export type ImageTwoColsBlockConfig = typeof imageTwoColsBlockConfig;
